import { string } from 'yup';

const deployDAOValidator = () => string().required('Required');

export { deployDAOValidator };
